
const Error404 = () => {
  return (
    <div className='min-h-screen w-screen flex flex-col items-center justify-center'>
      <h1 className="text-[5rem] font-bold mb-1">404</h1>
      <p className="font-semibold text-xl"> Oops! Page Not Found!</p>
    </div>
  );
}

export default Error404;